var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company_contracts_datatable',{attrs:{"row-data":_vm.contracts,"loading-message":'Loading Contracts...',"no-rows-message":'No Contracts Loaded',"columns":_vm.contracts_columns,"type":'contracts',"record-type":'company'}})
}
var staticRenderFns = []

export { render, staticRenderFns }